// extracted by mini-css-extract-plugin
export var container = "_hd-1";
export var editor = "_hd-2";
export var resizable = "_hd-3";
export var wrapper = "_hd-0";